import setAddress_ from './setAddress';
import setAltitudeByYear_ from './setAltitudeByYear';
import setCoordinate_ from './setCoordinate';
import setElevationByCoordinate_ from './setElevationByCoordinate';
import setPanoramaById_ from './setPanoramaById';
import setPopulation_ from './setPopulation';
import setElevation_ from './setElevation';

export const setAddress = setAddress_;
export const setAltitudeByYear = setAltitudeByYear_;
export const setCoordinate = setCoordinate_;
export const setPanoramaById = setPanoramaById_;
export const setPopulation = setPopulation_;
export const setElevation = setElevation_;
export const setElevationByCoordinate = setElevationByCoordinate_;
